/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import sessionSelectors from 'redux/reduxStore/session';

import navigationActions from 'redux/actions/navigation';
import uiStateActions from 'redux/actions/uiState';

import PageHeaderTemplate, { BackpackThemedPageHeaderTemplate, DashboardThemedPageHeaderTemplate, GroupThemedPageHeaderTemplate, GroupThemedLoggedOutPageHeaderTemplate } from './PageHeader.template';

import routeNames from 'lib/routeNames';
import AppUtils from 'lib/AppUtils';

function mapStateToProps(state) {
  return {
    isLoggedIn: sessionSelectors.isLoggedIn(state),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    openSidebar: () => {
      return dispatch(uiStateActions.openSidebar());
    },
    goLogin: () => {
      dispatch(navigationActions.goTo(routeNames.loginEmail()));
    },
  };
};

class PageHeader extends React.Component {
  render() {
    const { subTitle, mainTitle} = this.props;
    const onClickLogo = (!this.props.isLoggedIn && !!AppUtils.getGroupSubdomain()) ? this.props.goLogin : null;

    return (
      <PageHeaderTemplate
        goBack={this.props.goBack}
        titleClassName={this.props.titleClassName}
        titlePhrase={this.props.titlePhrase}
        subTitle={subTitle}
        mainTitle={mainTitle}
        isLoggedIn={this.props.isLoggedIn}
        openSidebar={this.props.openSidebar}
        onClickLogo={onClickLogo}
      />
    );
  }
}

const GroupThemedPageHeader = connect(mapStateToProps, mapDispatchToProps)(GroupThemedPageHeaderTemplate);
const DashboardThemedPageHeader = connect(mapStateToProps, mapDispatchToProps)(DashboardThemedPageHeaderTemplate);
const GroupThemedLoggedOutPageHeader = connect(mapStateToProps, mapDispatchToProps)(GroupThemedLoggedOutPageHeaderTemplate);
const BackpackThemedLoggedOutPageHeader = connect(mapStateToProps, mapDispatchToProps)(BackpackThemedPageHeaderTemplate);

export {
  GroupThemedPageHeader,
  DashboardThemedPageHeader,
  GroupThemedLoggedOutPageHeader,
  BackpackThemedLoggedOutPageHeader,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
